// extracted by mini-css-extract-plugin
module.exports = {"banner":"_3O-Gt","title":"_3PIRC","button":"_2GzDD","bannerTwo":"_1b51E","right":"_1X6zU"};